/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../../../types/graph';

import * as Operations from './query.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type BasicHealthInfoQueryVariables = SchemaTypes.Exact<{
  uuid: SchemaTypes.Scalars['ID']['input'];
  lifeApplicationId: SchemaTypes.Scalars['ID']['input'];
}>;


export type BasicHealthInfoQuery = { __typename?: 'Query', lifeApplication: { __typename?: 'LifeApplication', id: string, newPartnerReferral: boolean }, customer: { __typename?: 'Customer', id: string, hasLifeSpousalRelationship: boolean, userAttributes: string, identityProfile: { __typename?: 'IdentityProfile', id: string, age: number, dateOfBirth: string | null, email: string | null, gender: string | null }, residenceProfile: { __typename?: 'ResidenceProfile', id: string, zipCode: string | null, state: { __typename?: 'State', id: string, code: string } | null }, financialProfile: { __typename?: 'FinancialProfile', id: string, individualIncome: number | null, otherHouseholdIncome: number | null }, employmentProfile: { __typename?: 'EmploymentProfile', id: string | null, employmentType: string | null } | null } | null };


export function useBasicHealthInfoQuery(baseOptions: Apollo.QueryHookOptions<BasicHealthInfoQuery, BasicHealthInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BasicHealthInfoQuery, BasicHealthInfoQueryVariables>(Operations.BasicHealthInfo, options);
      }
export function useBasicHealthInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BasicHealthInfoQuery, BasicHealthInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BasicHealthInfoQuery, BasicHealthInfoQueryVariables>(Operations.BasicHealthInfo, options);
        }
export type BasicHealthInfoQueryHookResult = ReturnType<typeof useBasicHealthInfoQuery>;
export type BasicHealthInfoLazyQueryHookResult = ReturnType<typeof useBasicHealthInfoLazyQuery>;